<template>
  <div style="width: 100%">
    <div class="row">
      <!-- .blog_content_left_fm -->
      <div class="blog_content_left_fm col-lg-3 col-lg-4 col-md-5 col-sm-5">
        <div class="blog_info">
          <div class="author">{{$t('blog.content.author')}}</div>
          <div class="info_box">
            <p class="user_img"><img :src="blogDto.userLogoSmail" /></p>
            <div class="user_info">
              <p class="topimg_icon">
                <img :src="blogDto.sgL_UsersBLog" /><span class="txt">{{
                  info.sgL_BlogName
                }}</span>
              </p>
              <span class="txt"
                ><a
                  href="javascript:"
                  @click="
                    $router.push({
                      name: 'blogUserInfo',
                      query: { id: blogDto.sgL_UsersId },
                    })
                  "
                  >{{ blogDto.sgL_UsersName }}</a
                ></span
              >
              <span class="postime"
                ><i class="fas fa-users"
                  >{{$t('blog.content.Subscribernumber')}}: {{ info.sgL_SubscribeCount }}</i
                ></span
              >
            </div>
            <button
              type="button"
              class="btn btn-block btn-primary width"
              @click="sub"
            >
              {{ info.sgL_IsSubscribe ? $t('blog.content.Unsubscribe') : $t('blog.content.Subscribe') }}
            </button>
          </div>
        </div>

        <div class="blog_info">
          <div class="author">{{$t('blog.content.authorhighest')}}</div>
          <div
            class="topic_box"
            v-for="(item, ix) in list1"
            @click="
              $router.push({
                name: 'blogDetail',
                query: {
                  id: item.id,
                },
              })
            "
          >
            <p class="topic_img"><img :src="item.sgL_UploadTempUrl" /></p>
            <div class="description">
              <span class="title">{{ item.sgL_Title }}</span>
              <span class="txt2">{{
                item.sgL_Content.replace(/<\/?.+?>/g, "").replace(/ /g, "")
              }}</span>
              <span class="postime">{{ item.sgL_CreateTimeE }}</span>
            </div>
            <hr />
          </div>
        </div>

        <div class="blog_info">
          <div class="author">{{$t('blog.content.Popularpost')}}</div>
          <div
            class="topic_box"
            v-for="(item, ix) in list2"
            @click="
              $router.push({
                name: 'blogDetail',
                query: {
                  id: item.id,
                },
              })
            "
          >
            <p class="topic_img"><img :src="item.sgL_UploadTempUrl" /></p>
            <div class="description">
              <span class="title">{{ item.sgL_Title }}</span>
              <span class="txt2">{{
                item.sgL_Content.replace(/<\/?.+?>/g, "").replace(/ /g, "")
              }}</span>
              <span class="postime">{{ item.sgL_CreateTimeE }}</span>
            </div>
            <hr />
          </div>
        </div>
      </div>
      <!-- /.END blog_content_left_fm -->

      <!-- blog_content_right_fm -->
      <div class="col-lg-8 col-md-7 pl-md-3">
        <div class="blog_content_right_fm">
          <div class="blog_content">
            <!-- function icon -->
            <div
              class="function_icon"
              v-if="
                blogDto &&
                loginUser &&
                (blogDto.sgL_UsersId === loginUser.userId || loginUser.isAdmin)
              "
            >
              <div class="group_feedpost-more">
                <i class="fa fa-ellipsis-h"></i>
                <div class="group_reply-menus abc">
                  <a href="javascript:" @click="lookBlogUser">
                    <li class="follower"><i class="fas fa-bell"></i> {{$t('blog.content.subscriber')}}</li>
                  </a>
                  <a href="javascript:" @click="hideBlog">
                    <li class="hidpost">
                      <i class="fas fa-eye"></i>
                      {{ blogDto.sgL_IsShow ? $t('blog.content.Hidepost') : $t('blog.content.Display') }}
                    </li>
                  </a>
                  <a
                    href="javascript:"
                    data-toggle="modal"
                    data-target=".edit_post_text"
                    @click="editBlog"
                  >
                    <li class="mondify">
                      <i class="fas fa-edit"></i> {{$t('blog.content.Editpost')}}
                    </li>
                  </a>
                  <a href="javascript:" @click="deleteBlog">
                    <li class="delete">
                      <i class="far fa-trash-alt"></i> {{$t('blog.content.Delpost')}}
                    </li>
                  </a>
                </div>
              </div>
            </div>
            <!-- /.END function icon -->

            <div class="content_title">
              {{ blogDto.sgL_Title }}
            </div>
            <div class="option_icon" style="width: 100%">
              <div class="read_info" style="flex: 1">
                <span class="postime"
                  >{{$t('blog.content.Releasetime')}}: {{ blogDto.sgL_CreateTimeE }}</span
                >|
                <span class="viewtime"
                  ><i class="fas fa-eye"> {{ blogDto.sgL_ViewCount }}</i></span
                >|
                <span class="likes"
                  ><i class="fas fa-thumbs-up">
                    {{ blogDto.sgL_LikeCount }}</i
                  ></span
                >|
                <span class="share"
                  ><i class="fas fa-share">
                    {{ blogDto.sgL_SharCount }}</i
                  ></span
                >
              </div>
              <div class="recond_info">
                <p class="copylink">
                  {{ shortWebUrl }}
                  <a href="javascript:" @click="copyShortLink">{{$t('blog.content.copy')}}</a>
                </p>
                <div class="aaa">
                  <span
                    class="likes"
                    @click="
                      addfavorite(blogDto.id, blogDto.sgL_NewTypeId, 7, null, 1)
                    "
                    ><i class="fas fa-thumbs-up"> {{$t('blog.content.good')}}</i></span
                  >
                  <span
                    class="bookmark"
                    @click="
                      addfavorite(blogDto.id, blogDto.sgL_NewTypeId, 7, null, 0)
                    "
                    ><i class="fas fa-bookmark"> {{$t('blog.content.collect')}}</i></span
                  >
                  <span class="share" @click="share"
                    ><i class="fas fa-share"> {{$t('blog.content.share')}}</i></span
                  >
                  <span class="report" @click="report"
                    ><i class="fas fa-flag"> {{$t('blog.content.report')}}</i></span
                  >
                </div>
              </div>
            </div>
            <hr />
            <div class="content_txt">
              <div v-html="blogDto.sgL_Content"></div>
              <div style="padding-left: 10px" v-if="souceName">
                {{$t('blog.content.Reproducedsource')}} {{ souceName }}
              </div>
              <div style="padding-left: 10px" v-if="blogDto.sgL_KeyWord">
                {{$t('blog.content.Keywords')}} {{ blogDto.sgL_KeyWord }}
              </div>
            </div>
            <div class="blog_notes">
              {{$t('blog.content.blognotes')}}
            </div>
            <div class="read_page_button pt-2 pl-4 pr-4 pb-5">
              <a
                href="javascript:"
                class="read_pri float-left"
                @click="shang"
                v-if="this.info.previous"
              >
              {{$t('blog.content.Last')}}
              </a>
              <a
                href="javascript:"
                class="read_next float-right"
                @click="xia"
                v-if="this.info.next"
              >
              {{$t('blog.content.Next')}}
              </a>
            </div>
          </div>
          <div class="blog_chat_fm">
            <p class="blog_chat_title" style="border-radius: 8px">{{$t('blog.content.Leave')}}</p>
            <!-- #1 chat -->
            <div class="blog_reply" v-for="(item, ix) in commentList" :key="ix">
              <p class="blog_reply_no">#{{ ix + 1 }}</p>
              <!-- function icon -->
              <div
                class="function_icon"
                v-if="loginUser && item.sgL_Mem_Cid === loginUser.userId"
              >
                <div class="group_feedpost-more">
                  <i class="fa fa-ellipsis-h"></i>
                  <div class="group_reply-menus" style="right: 25px">
                    <a
                      href="javascript:"
                      @click="editComment(item.id, item.sgL_Msg_MContent)"
                    >
                      <li class="mondify">
                        <i class="fas fa-edit"></i> {{$t('blog.content.Editmessage')}}
                      </li>
                    </a>
                    <a href="javascript:" @click="delComment(item.id)">
                      <li class="delete">
                        <i class="far fa-trash-alt"></i> {{$t('blog.content.Delmessage')}}
                      </li>
                    </a>
                  </div>
                </div>
              </div>
              <!-- /.END function icon -->
              <div class="blog_reply_info">
                <p class="user_img"><img :src="item.sgL_ImageLogin" /></p>
                <div class="userinfo">
                  <span class="user_name">{{ item.sgL_Mem_DisplayName }}</span>
                  <span class="postime">{{ item.sgL_Msg_MAddTimerI }}</span>
                </div>
              </div>
              <div class="reply_content">
                {{ item.sgL_Msg_MContent }}
              </div>
            </div>
            <!--/.END #1 chat -->
            <!-- chat input box -->
            <div class="blog_reply">
              <p class="blog_reply_title">{{$t('blog.content.Leavemessage')}}</p>
              <hr />
              <div class="blog_reply_info">
                <p class="user_img"><img :src="loginUser.userLogoSmail" /></p>
                <div class="userinfo">
                  <span class="reply_user_name">{{
                    loginUser.displayName
                  }}</span>
                </div>
              </div>
              <input
                type="text"
                border="0"
                :placeholder="$t('blog.content.Leaveplaceholder')"
                class="reply_input"
                v-model="commentText"
              />
              <button
                type="button"
                class="btn btn-block btn-primary chat-input"
                @click="sendComment"
              >
              {{$t('blog.content.Haircloth')}}
              </button>
            </div>
            <!--/.END chat input box -->
          </div>
        </div>
      </div>
      <!-- /.END blog_content_right_fm -->
    </div>
    <div id="groupfriendlist" class="modal fade">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-content-title">
              {{$t('blog.content.Subscribed')}}:{{ blogIndex.SubscribeCount }}
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="feedpost-user friendlist_fm">
              <div
                class="friendlist_user"
                v-for="(item, ix) in blogIndex.blogSubList"
              >
                <a href="javascript:" class="friendlist_user">
                  <img class="user-logo" :src="item.userLogoBig" />
                  <span class="txt">{{ item.displayName }}</span></a
                >
              </div>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <ReportVue ref="report" :props_title="$t('blog.content.title')"></ReportVue>
    <div id="report-video2" class="modal fade">
      <div class="modal-dialog feedpost-ensize">
        <div class="modal-content ptrl-3">
          <div class="report-form-fm">
            <label for="video-name" class="mt-3">{{$t('blog.content.upPost')}}</label>
            <input
              class="form-control"
              type="text"
              placeholder=""
              maxlength="28"
              v-model="editCommentInfo.content"
            />
            <div class="">
              <button
                type="button"
                class="btn-st-2"
                :title="$t('blog.content.Confirmsubmission')"
                @click="editCommentReq"
              >
                <span>{{$t('blog.content.Confirmsubmission')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportVue from "../common/Report.vue";
import base from "../../api/httpApi/base";
export default {
  components: { ReportVue },
  data() {
    return {
      commentText: "",
      commentList: [],
      shortWebUrl: "",
      blogDto: {},
      info: {},
      list1: [],
      list2: [],
      editCommentInfo: {
        id: 0,
        content: "",
      },
      souceName: "",
      blogIndex: {
        blogPage: 0,
        blogDataList: [],
        pageParams: {
          currentPage: 1,
          limit: 5,
          total: 0,
        },
        blogSubList: [],
        SubscribeCount: 0,
      },
      ReprintedSourceList: [],
    };
  },
  async created() {
    this.shortWebUrl = this.getSortLink(this.$route.query.id, "E");
    await this.getReprintedSource();
    await this.GetIdByContent();
    this.GetAllByUserId();
    this.getAll();
    this.getComment();
  },
  methods: {
    async getReprintedSource() {
      const res = await this.$api.blog.getReprintedSource({
        SkipCount: 0,
        MaxResultCount: 99999,
      });
      this.ReprintedSourceList = res.data.result.items;
    },
    share() {
      let urlb = escape(
        `/Home/facebookResp?id=${this.$route.query.id}&type=blog`
      );
      window.open(`${this.$shareUrl}${base.url}${urlb}`, "_blank");
    },
    editComment(id, content) {
      this.editCommentInfo.id = id;
      this.editCommentInfo.content = content;
      $("#report-video2").modal("show");
    },
    editCommentReq() {
      let params = {
        id: this.editCommentInfo.id,
        sgL_Msg_MContent: this.editCommentInfo.content,
      };
      this.$api.common.updateMsg(params).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          $("#report-video2").modal("hide");
          this.getComment();
        }
      });
    },
    delComment(Id) {
      let params = {
        Id,
      };
      this.$api.common.deleteMsg(params).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          this.getComment();
        }
      });
    },
    sendComment() {
      if (this.loginUser === null) {
        this.$router.push({ name: "customerLogin" });
        return;
      }
      let params = {
        sgL_PG_CBigsort: this.blogDto.sgL_NewTypeId,
        sgL_PG_Coid: this.blogDto.id,
        sgL_Msg_Type: 8,
        sgL_Msg_MContent: this.commentText,
        sgL_Msg_SendType: 0,
        SGL_Mem_FinallyReceive_Cid: this.blogDto.sgL_UsersId,
      };
      this.$api.albumApi.createMessage(params).then((res) => {
        if (res.data.success) {
          this.commentText = "";
          this.getComment();
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
    },
    getComment() {
      let params = {
        SGL_PG_Coid: this.$route.query.id,
        SGL_Msg_Type: 8,
      };
      this.$api.albumApi.getMessageByTypeId(params).then((res) => {
        if (res.data.success) {
          this.commentList = res.data.result.items;
        }
      });
    },
    report() {
      //判断是否登陆，然后弹窗提示登陆
      if (this.loginUser === null) {
        this.$router.push({ name: "customerLogin" });
        return;
      }
      this.$refs.report.init(this.blogDto.id, this.info.sgL_UsersName, 7, null);
    },
    addfavorite(tid, type, Ftype, longid, DevicesType) {
      //判断是否登陆，然后弹窗提示登陆
      if (this.loginUser === null) {
        this.$router.push({ name: "customerLogin" });
        return;
      }
      let params = {
        sgL_DevicesType: DevicesType,
        sgL_MasterSort: type, //类型
        sgL_PG_Coid: tid, //图册、影片、文章、活动的id
        sgL_Fav_FType: Ftype, //图册：0，图片：1，影片：2
        sgL_Fav_FBelongidc: longid, //图片id
      };
      this.$store.dispatch("addfavorite", params).then((res) => {
        if (res) {
          this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
        }
      });
    },
    copyShortLink() {
      this.copyToClipboard(this.shortWebUrl, true);
    },
    sub() {
      if (this.loginUser === null) {
        this.$router.push({ name: "customerLogin" });
        return;
      }
      this.$api.blog
        .SubscribeCreate({
          sgL_BlogId: this.blogDto.id,
          sgL_SubscribeUsersId: this.blogDto.sgL_UsersId,
        })
        .then((res) => {
          if (res.data.success) {
            this.GetIdByContent();
            this.$message.success(this.$t('message.operatesuccessfully'));
          } else {
            this.$message.error(res.data.error.message);
          }
        });
    },
    hideBlog() {
      this.$api.blog.UpdateIsShow({ id: this.blogDto.id }).then((res) => {
        this.GetIdByContent();
        this.$message.success(this.$t('message.operatesuccessfully'));
      });
    },
    editBlog() {
      this.$router.push({
        name: "customerPublish",
        query: {
          editBlogId: this.blogDto.id,
        },
      });
    },
    deleteBlog() {
      this.$api.blog.Delete({ id: this.blogDto.id }).then((res) => {
        this.$router.push({ name: "blogAll" });
        this.$message.success(this.$t('message.operatesuccessfully'));
      });
    },
    lookBlogUser() {
      this.blogIndex.SubscribeCount = 0;
      this.blogIndex.blogSubList = [];
      let params = {
        Id: this.blogDto.id,
        SkipCount: 0,
        MaxResultCount: 9999, //查多少条
      };
      this.$api.blog.GetMySubscribeList(params).then((res) => {
        this.blogIndex.blogSubList = res.data.result.items;
        this.blogIndex.SubscribeCount = res.data.result.totalCount;
      });
      $("#groupfriendlist").modal("show");
    },
    shang() {
      if (this.info.previous) {
        this.$router.push({
          name: "blogDetail",
          query: {
            id: this.info.previous,
          },
        });
      }
    },
    xia() {
      if (this.info.next) {
        this.$router.push({
          name: "blogDetail",
          query: {
            id: this.info.next,
          },
        });
      }
    },
    GetAllByUserId() {
      let params = {
        SkipCount: 0,
        MaxResultCount: 4,
        sgL_UsersId: this.info.sgL_UsersID,
        sorting: "QueriesCount",
        sgL_IsShow: true,
      };
      this.$api.blog.GetAllByUserId(params).then((res) => {
        this.list1 = res.data.result.blogDto.items;
      });
    },
    getAll() {
      let params = {
        SkipCount: 0,
        MaxResultCount: 4,
        sorting: "QueriesCount",
        sgL_NewTypeId: this.blogDto.sgL_NewTypeId,
        sgL_IsShow: true,
      };
      this.$api.blog.GetAll(params).then((res) => {
        this.list2 = res.data.result.items;
      });
    },
    async GetIdByContent() {
      const res = await this.$api.blog.GetIdByContent({
        id: this.$route.query.id,
      });
      this.info = res.data.result;
      this.blogDto = this.info.blogDto;
      const sourceInfo = this.ReprintedSourceList.find(
        (c) => c.id === this.blogDto.sgL_ReprintedId
      );
      if (sourceInfo) {
        this.souceName = sourceInfo.sgL_Title;
      }
      this.$parent.setCurrent(this.blogDto.sgL_NewTypeId);
    },
  },
};
</script>

<style scoped>
.list_post .list_info {
  overflow: inherit;
}

.group_reply-menus {
  right: 0 !important;
}
.group_feedpost-more:hover > .abc {
  display: block;
}
.group_feedpost-more:hover > .abc a {
  display: block;
  width: 100%;
  padding: 8px 12px;
}
.aaa:hover span {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/blog/content.vue